import url from 'url';
import { imgixDomain } from 'commons/constants';

const addDomainToPath = path => {
  if (!path || typeof path !== 'string' || !path.trim()) {
    return '';
  }
  return url.resolve(imgixDomain, path);
};

export default addDomainToPath;
